import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { noop } from 'lodash-es';
/* Utils */
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';

export function ExpiredScreenError({ clearFinancingPath = noop, isMatchingVIN = false, isPreVinFlow = false }) {
  const url = '../basics';

  useEffect(
    () => {
      clearFinancingPath();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    []
  );

  return (
    <div
      className="text-center"
      data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'expired' })}
    >
      <h2 className="size-30 fw-bold mb-1">Pre-Qualification Request Expired</h2>
      <h4 className="size-20 mb-1 fw-normal">
        <div>Unfortunately your previous application has expired.</div>
      </h4>
      <div className="mb-1">Please create a new application to get pre-qualified for your vehicle.</div>
      <div className="d-flex justify-content-center">
        <Button
          className="px-1 mb-2 text-white text-decoration-none text-capitalize size-16 fw-normal"
          tag={Link}
          to={url}
          color="primary-b"
          rel="nofollow"
        >
          Get Started
          <i className="ms-0_5 size-12 icon-arrow-right4" aria-hidden />
        </Button>
      </div>
    </div>
  );
}

ExpiredScreenError.propTypes = {
  clearFinancingPath: PropTypes.func,
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
